import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Table from '../../../../../../components/table/Table';


export default class Stolen extends Component {
    render() {
        if (this.props.details.length > 0) {
            return (
                <Row>
                    <Col md="12">
                        <Table responsive className="table--bordered hpi" style={this.props.style}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Constabulary</th>
                                    <th>Contact Number</th>
                                    <th>Description</th>
                                    <th>Date</th>
                                    <th>Stolen Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.details.map((item, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{item.force}</td>
                                        <td>{item.contact_number}</td>
                                        <td>{item.status}</td>
                                        <td>{item.creation_date}</td>
                                        <td>{item.transaction_date}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about this bike being stolen</p></Col></Row>);
    }
}

Stolen.propTypes = {
    details: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/stolen.js